<template>
  <AuthLayout :title="$route.params.token ? 'Activation du compte' : 'Confirmez votre adresse e-mail'">
    <SendConfirmMail v-if="this.$route.params.token"/>
    <AskConfirmMail v-else/>
  </AuthLayout>
</template>

<script>
    import AskConfirmMail from "@/components/forms/AskConfirmMail.vue";
    import SendConfirmMail from "@/components/forms/SendConfirmMail.vue";
    import AuthLayout from "@/components/public/AuthLayout.vue";

    export default {
        name: 'ConfirmMailView',
        components: {
          SendConfirmMail,
          AskConfirmMail,
          AuthLayout,
        }
    }
</script>
